import type { AnyActorRef, AnyStateMachine, EventFromLogic } from 'xstate'
import { createActor } from 'xstate'
import { BaseTool } from './BaseTool'

/**
 * 基于 xstate 的工具基类，管理 Actor 生命周期并提供发送/匹配快捷方法。
 *
 * @typeParam T - xstate 状态机类型
 */
export abstract class StateMachineTool<T extends AnyStateMachine> extends BaseTool {
  // 存储当前的 Actor 实例
  private actor: AnyActorRef | null = null

  /**
   * 必须在子类中定义状态机
   */
  protected abstract machine: T

  /**
   * 初始化：创建并启动 Actor
   */
  protected initialize(...args: any[]) {
    // 避免重复启动
    if (this.actor) {
      return
    }

    // 创建 Actor
    this.actor = createActor(this.machine)
    this.actor.start()
    this.onInitialize(...args)
  }
  protected abstract onInitialize(...args: any[]): void

  /**
   * 终止：销毁 Actor 并清理引用
   */
  protected terminate() {
    this.onTerminate()
    this.actor?.stop()
    this.actor = null
  }
  protected abstract onTerminate(): void

  /**
   * 发送事件的快捷方法
   */
  protected send(event: EventFromLogic<T>) {
    if (!this.actor) {
      return
    }
    this.actor.send(event)
  }

  /**
   * 检查当前状态是否匹配给定状态名称
   */
  protected checkState(stateName: string): boolean {
    return this.actor?.getSnapshot().matches(stateName) ?? false
  }
}
